export const FEATURE_IDS = {
    ONLINE_MENU: "2bccfb23-cb71-42fb-904e-c161a02f95ae",
    TICKETS: "fd78b4ae-e1d8-4cbc-b4fc-049c8cd859ec",
    RECURRING_TICKETS: "cfbe0acf-7193-457e-84a9-430e2693fd24",
    USERS: "59f6cffd-3892-4d78-8860-781d910de446",
    CHAT: "c82d4a28-172b-4db9-a6ea-0a759e530c39",
    CAREERS: "3ca5c970-19ed-4594-ad54-a4e2c502e115",
    EXPIRATION_CHECK: "26bc8c60-c71d-46f5-898d-d054d38fd0b6",
    LINKS: "f6ae38ca-4d93-4c19-9dcf-67e1360882bb",
    PRICE_LISTS: "50b61f90-fd5f-47fe-ae3c-b8c7cc98ae72",
};

export const featureRoutes = [
    { id: FEATURE_IDS.ONLINE_MENU, name: "Online jelovnik", link: "/online-menu" },
    { id: FEATURE_IDS.TICKETS, name: "Zadaci", link: "/tickets" },
    { id: FEATURE_IDS.RECURRING_TICKETS, name: "Ponavljajući zadaci", link: "/recurring-tickets" },
    { id: FEATURE_IDS.USERS, name: "Korisnici", link: "/users" },
    { id: FEATURE_IDS.CHAT, name: "Virtualni asistent", link: "/chat" },
    { id: FEATURE_IDS.CAREERS, name: "Karijere", link: "/careers" },
    { id: FEATURE_IDS.EXPIRATION_CHECK, name: "Provjera isteka", link: "/expiration-check" },
    { id: FEATURE_IDS.LINKS, name: "Poveznice", link: "/links" },
    { id: FEATURE_IDS.PRICE_LISTS, name: "Sidreni cjenici", link: "/price-lists" },
];
